// extracted by mini-css-extract-plugin
export default {"restrictedWidth":"columns_restrictedWidth__UrVIS","restrictedWidthHalf":"columns_restrictedWidthHalf__yvmmc","placeHolderShimmer":"columns_placeHolderShimmer__Eepaz"};